// extracted by mini-css-extract-plugin
module.exports = {"uhOh":"s-module--uhOh--2K5JR"};